import { combineReducers } from 'redux';
import { cardReducer } from './card-reducer';
import { challengeReducer } from './challenge-reducer';
import { configReducer } from './config-reducer';
import { emailReducer } from './email-reducer';
import { methodReducer } from './method-reducer';
import { notificationReducer } from './notification-reducer';
import { overlayReducer } from './overlay-reducer';

export const rootReducer = combineReducers({
  config: configReducer,
  card: cardReducer,
  challengeData: challengeReducer,
  email: emailReducer,
  methods: methodReducer,
  notification: notificationReducer,
  overlay: overlayReducer,
});
